import {  useEffect } from "react";
function Mars() {



 
  
   useEffect(() => {
    
  },[]); 
    return (
      <>
      <div className=" mt-2  p-1 container mx-auto   ">
        <h1 className="">Follow me on : </h1>
        <div class="m-1 flex flex-wrap justify-center ">
         
         <div  class=" m-1 border shadow-ld flex items-center w-full max-w-xs p-4 space-x-4 text-gray-500 bg-white divide-x divide-gray-200 rounded-lg shadow  space-x " role="alert">
           <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"></path><path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"></path></svg>      <div class="pl-4 text-sm font-normal">
             <a class="p-2 hover:text-gray-500 font-bold" href="https://twitter.com/ElkarroumyTaha">Twitter</a>
           </div>
         </div>
     
         <div  class=" m-1 border shadow-ld flex items-center w-full max-w-xs p-4 space-x-4 text-gray-500 bg-white divide-x divide-gray-200 rounded-lg shadow  space-x " role="alert">
           <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"></path><path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"></path></svg>      <div class="pl-4 text-sm font-normal">
             <a class="p-2 hover:text-gray-500 font-bold" href="https://medium.com/@elkarroumytaha">Medium</a>
           </div>
         </div>
     
         <div  class=" m-1 border shadow-ld flex items-center w-full max-w-xs p-4 space-x-4 text-gray-500 bg-white divide-x divide-gray-200 rounded-lg shadow  space-x " role="alert">
           <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"></path><path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"></path></svg>      <div class="pl-4 text-sm font-normal">
             <a class="p-2 hover:text-gray-500 font-bold" href="https://github.com/t-el">Github</a>
           </div>
         </div>
       
         </div>
      </div>

      </>
    );
  }
  
  export default Mars ;
